import React from 'react';

import { Button, Skeleton, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import SsoTableRow from './SsoTableRow';
import AdminAuthContainer from '../../AdminAuthContainer';
import AdminSsoContainer, { SsoView } from '../../AdminSsoContainer';


const StyledTable = styled(Table)`
    margin-top: 12px;
`;

const StyledSkeleton = styled(Skeleton)`
    height: 70px;
`;

const StyledHeaderContainer = styled.div`
    display: flex;
    margin-bottom: 10px;
`;

const StyledTitle = styled(Typography)`
    font-size: 24px;
    margin-right: auto;
`;

const StyledButton = styled(Button)`
    margin-left: 15px;
`;

const SsoList: React.FC = () => {
    const { isAdmin, isLoading } = useContainer(AdminAuthContainer);
    const { t } = useTranslation('admin_settings');
    const history = useHistory();
    const { path } = useRouteMatch();
    const { idps,
        ssoFetchStatus,
        selectedIdp,
        setView,
        setIdpId,
        setSelectedIdp }
        = useContainer(AdminSsoContainer);


    const handleCreateNewSso = () => {
        setView(SsoView.Create);
        setIdpId(null);
        setSelectedIdp(null);
        history.push(`${path}/create`);
    };


    const TableSkeletons = () => (
        <>
            <StyledSkeleton />
            <StyledSkeleton />
            <StyledSkeleton />
            <StyledSkeleton />
        </>
    );

    const renderTable = () => {
        if (ssoFetchStatus === 'SUCCESS' && !isLoading) {
            return (
                <StyledTable>
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('sso.display-name')}</TableCell>
                            <TableCell>{t('sso.domain')}</TableCell>
                            <TableCell>{t('sso.is-active')}</TableCell>
                            <TableCell align='center'>{t('sso.test-link')}</TableCell>                            
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {idps.map((idp, index) => (<>
                            <SsoTableRow key={index} data={idp} />
                        </>
                        ))}
                    </TableBody>
                </StyledTable>
            );
        }
        return <TableSkeletons />;
    };


    return (
        <>
            <StyledHeaderContainer>
                <StyledTitle variant='h1'>{t('sso.sso')}</StyledTitle>
                <StyledButton variant='contained' onClick={handleCreateNewSso}  >{t('sso.add-new-sso')}</StyledButton>
            </StyledHeaderContainer>
            {renderTable()}

        </>
    );
};

export default SsoList;
